import { Award } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

interface PersonalBestBadgeProps {
  rank: number | null | undefined;
  size?: "sm" | "md" | "lg";
}

export function PersonalBestBadge({ rank, size = "md" }: PersonalBestBadgeProps) {
  if (!rank || rank < 1 || rank > 3) {
    return null;
  }

  const colors = {
    1: "text-yellow-500", // Gold
    2: "text-gray-400", // Silver
    3: "text-amber-600", // Bronze
  };

  const bgColors = {
    1: "bg-yellow-500/10",
    2: "bg-gray-400/10",
    3: "bg-amber-600/10",
  };

  const sizes = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  const labels = {
    1: "1st",
    2: "2nd",
    3: "3rd",
  };

  const tooltipMessages = {
    1: "Your fastest lap ever at this track in this car",
    2: "Your second fastest lap ever at this track in this car",
    3: "Your third fastest lap ever at this track in this car",
  };

  const textSizes = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base",
  };

  const paddingSizes = {
    sm: "px-2 py-0.5",
    md: "px-2.5 py-1",
    lg: "px-3 py-1.5",
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`inline-flex items-center gap-1.5 rounded-full ${bgColors[rank as keyof typeof bgColors]} ${paddingSizes[size]} cursor-default`}
          >
            <Award className={`${sizes[size]} ${colors[rank as keyof typeof colors]}`} />
            <span className={`font-semibold ${textSizes[size]} ${colors[rank as keyof typeof colors]}`}>
              {labels[rank as keyof typeof labels]}
            </span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipMessages[rank as keyof typeof tooltipMessages]}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
